export default __webpack_public_path__ + "static/media/is_dead_red.da9173d6.png";